var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-checkbox',_vm._g(_vm._b({attrs:{"label":_vm.label,"hide-details":_vm.hideDetails},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'v-checkbox',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }